(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product"]) return;
  try {
    
    document.querySelectorAll('.product__title').forEach(function(element) {element.textContent = element.textContent.split(' | ')[0];})
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-product"] && !Shopify.designMode) return;
  try {
    
    document.querySelectorAll('.product__title').forEach(function(element) {element.textContent = element.textContent.split(' | ')[0];})
  
  } catch(e) { console.error(e); }
})();
})();
